const DEFAULT = ["starters", "small plates", "mains", "sides", "desserts", "drinks"];

export function groupMenu(dishes, order = []) {
  const rank = (c) => {
    const i = order.indexOf(c);
    if (i >= 0) return i;
    const j = DEFAULT.indexOf(c.toLowerCase());
    return order.length + (j < 0 ? DEFAULT.length : j);
  };
  const groups = {};
  dishes.forEach((d) => { (groups[d.category || "Menu"] ||= []).push(d); });
  const byPos = (a, b) => (a.position ?? 1e6) - (b.position ?? 1e6) || a.name.localeCompare(b.name);
  return Object.entries(groups).sort(([a], [b]) => rank(a) - rank(b) || a.localeCompare(b)).map(([cat, ds]) => [cat, ds.sort(byPos)]);
}

export const orderedDishes = (dishes, order) => groupMenu(dishes, order).flatMap(([, ds]) => ds);
